import React, { Component } from 'react';

import ReceiveNumberTable from '../ReceiveNumberTable';

class ReceiveNumber extends Component {
  constructor(){
    super();

    this.state = {
      receive_number_id: null
    }

    this.handleSelectReceiveNumber = this.handleSelectReceiveNumber.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSelectReceiveNumber(row, isSelected, e){
    this.setState({
      receive_number_id: row.id
    });
  }

  handleSubmit(){
    this.props.onSubmitAction(this.state.receive_number_id);
  }

  render(){
    return(
      <div>
        <ReceiveNumberTable onSelect={this.handleSelectReceiveNumber} typeName={this.props.type_name} />

        <div className="modal-footer row">
              <button type='button' className="btn btn-primary pointer" disabled={this.props.clicked} onClick={this.handleSubmit}>ยืนยัน</button>
          <button type='button' className="btn btn-secondary pointer" onClick={this.props.onCloseModal}>ยกเลิก</button>
        </div>
      </div>
    )
  }
}

export default ReceiveNumber;



// WEBPACK FOOTER //
// ./src/components/WorkflowActions/ReceiveNumber.js